// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"153":"4f034e44","230":"2bb8f09f","653":"9385ffc3","667":"4f034e44"}[chunkId] + ".css";
};